import { render, staticRenderFns } from "./PredefinedStatusesList.vue?vue&type=template&id=fddcc16e&scoped=true&"
import script from "./PredefinedStatusesList.vue?vue&type=script&lang=js&"
export * from "./PredefinedStatusesList.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedStatusesList.vue?vue&type=style&index=0&id=fddcc16e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddcc16e",
  null
  
)

export default component.exports